<template>
  <div class="bg-white">
    <Header :title="title" :leftHandler="back"></Header>
    <div class="page">
      <div v-if="showPage === -1">
        <div class="notice-bar" v-if="clientList.length">
          <div class="notice-bar-info">提示：您的手机号存在关联的易加网账号，请选择您需要的账号进行授权绑定</div>
        </div>
        <WorkshopBox :clientList="clientList" :kongzTokenDTO="kongzTokenDTO" @selectItem="handleShowPage"></WorkshopBox>
        <div class="text-center no-message" :class="{ 'margin-t-50': !clientList.length }">
          <p class="font-normal">若未找到易加网修理厂账号，您可选择</p>
          <p><van-button type="primary" size="large" @click="handleShowPage()" style="width:80%;">注册修理厂</van-button></p>
        </div>
      </div>
      <!-- 店主授权 -->
      <VerifyClient :clientInfo="clientInfo" :kongzTokenDTO="kongzTokenDTO" v-if="showPage === 1"
        :fixedButtonText="fixedButtonText" @submit="submit"></VerifyClient>
      <!-- 新建修理厂 -->
      <AddClient :clientInfo="clientInfo" :kongzTokenDTO="kongzTokenDTO" v-if="showPage === 2" ref="addClient"
        :fixedButtonText="fixedButtonText" @submit="submit"></AddClient>
      <!-- 关联负责人 -->
      <RelateClientUser :clientInfo="clientInfo" :kongzTokenDTO="kongzTokenDTO" v-if="showPage === 3"
        :fixedButtonText="fixedButtonText" @submit="submit"></RelateClientUser>
      <!-- 新建负责人 -->
      <AddClientUserVue :clientInfo="clientInfo" :kongzTokenDTO="kongzTokenDTO" v-if="showPage === 4" ref="addClientUser"
        :fixedButtonText="fixedButtonText" @submit="submit">
      </AddClientUserVue>
    </div>
    <!-- 新用户注册dialog 有优惠券 -->
    <van-dialog v-model="firstMonthDialog.show" title="成功绑定易加网" :message="fixedButtonText + '成功'"
      v-if="activityData && activityData.coupon && firstMonthDialog.show" :showCancelButton="false"
      :confirmButtonText="firstMonthDialog.confirmButtonText" @confirm="dialogBind(2)">
      <template #default>
        <div class="text-center van-dialog__message van-dialog__message--has-title">
          <div @click="goToHome" class="close"> <van-icon name="cross" /> </div>
          <p>恭喜您获得<span class="color-green">"{{ firstMonthDialog.message }}"</span></p>
          <!-- <p>200积分大礼包已到账</p> -->
          <!-- <p>点击下方按钮即刻领取其余好礼</p> -->
        </div>
      </template>
    </van-dialog>
    <!-- 新用户注册dialog 无优惠券 -->
    <van-dialog v-model="firstMonthDialog.show" title="恭喜您成功绑定易加网"
      v-if="activityData && !activityData.coupon && firstMonthDialog.show" :showCancelButton="false"
      :confirmButtonText="好的" @confirm="goToHome">
      <template #default>
        <div class="text-center van-dialog__message van-dialog__message--has-title">
          <div @click="goToHome" class="close"> <van-icon name="cross" /> </div>

          <!-- <p>200积分大礼包已到账</p> -->
          <!-- <p>点击下方按钮即刻领取其余好礼</p> -->
        </div>
      </template>
    </van-dialog>
    <!-- 无法关联dialog -->
    <van-dialog v-model="cannotShow" title="无法关联" :show-cancel-button="false" confirmButtonText="确定"
      @confirm="dialogBind()">
      <template #default>
        <div class="text-center van-dialog__message van-dialog__message--has-title">
          <p>当前手机号已绑定另一家修理厂</p>
          <p style="color:var(--base-green)" @click="toLogin">点击登录查看</p>
        </div>
      </template>
    </van-dialog>
    <ReturnToLogin ref="ReturnToLogin" @after-confirm="handleJumpHome"></ReturnToLogin>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import AddClient from './components/addClient.vue'
import VerifyClient from './components/verifyClient.vue'
import AddClientUserVue from './components/addClientUser.vue'
import RelateClientUser from './components/relateClientUser.vue'
import ReturnToLogin from '@/views/activity/components/return-to-login.vue'
import cartApi from '@/api/cart'
import WorkshopBox from './components/workshopBox.vue'
import { kangzhongApi } from '@/api/bind'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  components: {
    Header,
    AddClient,
    VerifyClient,
    AddClientUserVue,
    RelateClientUser,
    WorkshopBox,
    ReturnToLogin
  },
  data () {
    return {
      token: '',
      clientList: [],
      isKeyRole: 0,

      showPage: 0, // -1维修站列表；1维修站手机号验证; 2 新建维修站；3未关联；4新建;

      currentClientUser: null,
      kongzTokenDTO: {
        name: '',
        phone: '',
        uuid: '',
        organizationCode: ''
      },
      clientInfo: {
        clientName: '',
        detailAddress: '',
        contactMobile: '',
        contactPerson: ''
      },
      fromApp: '',
      firstMonthDialog: {
        show: false,
        message: '',
        confirmButtonText: '立即使用'
      },
      cannotShow: false,
      params: {},
      clientToken: {},
      targetUrl: '/v2/home-main',
      fixedButtonText: '',
      title: '',
      goBuy: false,
      coupon: {},
      cartId: '',
      activityData: null
    }
  },
  computed: {},
  created () {
    this.fromApp = this.$route.query.appCode || ''
    this.token = this.$route.query.oauthToken || ''
    commonUtils.reportViewTrace({ metaValue: this.token })
    this.queryBind()
  },
  methods: {
    // 绑定修理厂查询
    queryBind () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      kangzhongApi.queryBind({ token: this.token }).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          const { kongzTokenDTO, clientList, workshopBinding } = res.data.resultData
          this.kongzTokenDTO = kongzTokenDTO || {}
          this.clientList = clientList || []
          if (!this.clientList.length) { // 新建修理厂
            this.showPage = 2
            this.title = '新建修理厂'
            this.fixedButtonText = '新建'
            this.handleShowPage()
            return
          }
          if (workshopBinding === 0) { // 多家修理厂
            this.showPage = -1
            this.title = '维修站列表'
          } else if (workshopBinding === 1) { // 一家修理厂
            this.handleShowPage(this.clientList[0])
          }
        } else if (res.data.resultCode === '29991') {
          // 无法关联
          this.cannotShow = true
        } else {
          this.$dialog.alert({ message: res.data.resultMsg }).then(() => { })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    // 选择修理厂
    handleShowPage (item) {
      if (item) {
        let param = {
          clientId: item.clientId,
          uuid: this.kongzTokenDTO.uuid,
          phone: this.kongzTokenDTO.phone,
          name: this.kongzTokenDTO.name
        }
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        kangzhongApi.getBindClientInfo(param).then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            const { currentClient, currentClientUser, isKeyRole } = res.data.resultData
            this.clientInfo = currentClient || ''
            this.currentClientUser = currentClientUser || ''
            this.isKeyRole = isKeyRole || 0
            console.log('0000000===', this.activityData)
            if (this.isKeyRole === 0) {
              if (this.currentClientUser) {
                this.showPage = 3 // 未关联
                this.title = '修理厂授权绑定'
                this.fixedButtonText = '授权绑定'
              } else {
                this.showPage = 4 // 新建关联
                this.title = '新建修理厂并授权绑定'
                this.fixedButtonText = '新建并授权绑定'
                // this.$nextTick(function () {
                //   this.$refs.addClientUser.queryUser()
                // })
              }
            } else {
              this.showPage = 1 // 维修站手机号验证
              this.title = '修理厂授权绑定'
              this.fixedButtonText = '授权绑定'
            }
          }
        }).catch(() => { this.$toast.clear() })
      } else {
        this.showPage = 2
        this.title = '新建修理厂'
        this.fixedButtonText = '新建'
        // this.$nextTick(function () {
        //   this.$refs.addClient.queryUser()
        // })
      }
    },
    // 通过搜索选择修理厂
    handleSearchClient (item) {
      this.showPage = 5
      this.clientInfo = item
      this.title = '修理厂授权绑定'
    },
    // 提交
    submit (data) {
      data.fromApp = this.fromApp
      data.organizationCode = this.kongzTokenDTO.organizationCode
      data.token = this.token
      // if (!data.name) {
      //   this.$toast('姓名不能为空')
      //   return
      // }
      // if (!data.verifyCode) {
      //   this.$toast('验证码不能为空')
      //   return
      // }
      this.params = data
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      console.log('qqqqqqqqqqq===============================================')
      // 绑定接口
      kangzhongApi.bindExternal(this.params).then(res => {
        console.log('11111111===', this.activityData)
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          const { clientToken, activityData } = res.data.resultData
          this.clientToken = clientToken
          this.activityData = activityData
          console.log('2222222222======================', this.activityData)
          let params = {
            ut: this.clientToken.token,
            loginType: 'WX'
          }
          kangzhongApi.entryValidate(params).then(response => {
            this.$toast.clear()
            if (response.data.resultCode === '0') {
              userUtils.setUserLocal(response.data.resultData)
              if (response.data.resultData.activityCoinDTO) {
                // 回归活动
                this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(response)
              } else {
                this.handleJumpHome()
              }
            }
          }).catch(() => { this.$toast.clear() })
        }
      }).catch(() => { this.$toast.clear() })
    },
    // 登录并跳转
    entryValidate (token) {
      console.log('33333333===', this.activityData)
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '登录中'
      })
      let params = {
        ut: token,
        loginType: 'WX'
      }
      kangzhongApi.entryValidate(params).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          userUtils.setUserLocal(res.data.resultData)
          if (res.data.resultData.activityCoinDTO) {
            // 回归活动
            this.$refs['ReturnToLogin'] && this.$refs['ReturnToLogin'].open(res)
          } else {
            this.handleJumpHome()
          }
        }
      }).catch(() => { this.$toast.clear() })
      this.firstMonthDialog.show = false
    },
    handleJumpHome () {
      // 新用户首月注册活动
      console.log('this.activityData===', this.activityData)
      if (this.activityData) {
        // this.targetUrl = activityData.uri
        if (this.activityData.coupon) {
          this.goBuy = true
          this.coupon = this.activityData.coupon
        }
        this.firstMonthDialog.show = true
        this.firstMonthDialog.message = this.activityData.itemNameList.join('+')
      } else {
        window.location.replace(this.targetUrl)
      }
    },
    // dialog 按钮
    dialogBind (mode) {
      if (mode === 2) {
        // 如果有卡券
        if (this.goBuy) {
          const payload = {
            itemQuantity: 1,
            itemId: this.coupon.limitItemId,
            couponId: this.coupon.couponId
          }
          // 调使用卡券接口
          cartApi.queryCartBuy(payload).then(res => {
            if (res.data.resultCode === '0') {
              // 获取carId
              cartApi.getCartList().then(res => {
                if (res.data.resultCode === '0') {
                  const { cartList } = res.data.resultData
                  this.cartList = cartList
                  const index = this.cartList.findIndex(item => {
                    return item.itemId === this.coupon.limitItemId
                  })
                  if (index !== -1) {
                    this.cartId = this.cartList[index].cartId
                  }
                  // 跳转创建订单页
                  let data = [{
                    itemId: this.coupon.limitItemId,
                    selected: 1,
                    cartId: this.cartId
                  }]
                  cartApi.checkSettlement(data).then(res => {
                    if (res.data.resultCode === '0') {
                      this.$router.push({
                        name: 'orderCreate',
                        params: {
                          selectCouponId: this.coupon.couponId
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        } else {
          window.location.replace(this.targetUrl)
        }
        // this.firstMonthDialog.show = false
        // this.entryValidate(this.clientToken.token)
      } else {
        this.$router.replace({ name: 'home-main' })
      }
    },
    goToHome () {
      this.goBuy = false
      this.dialogBind(2)
      // this.entryValidate(this.clientToken.token)
    },
    // 点击登录查看
    toLogin () {
      this.$router.replace({
        name: 'login2'
      })
      this.cannotShow = false
    },
    // 返回
    back () {
      if ([-1, 0].includes(this.showPage)) {
        this.$router.go(-1)
      }
      if ([1, 2, 3, 4].includes(this.showPage)) {
        this.showPage = -1
        this.title = '维修站列表'
      }
      // Object.keys(this.clientInfo).forEach(key => {
      //   this.clientInfo[key] = ''
      // })
      Object.keys(this.params).forEach(key => {
        this.params[key] = ''
      })
      Object.keys(this.clientToken).forEach(key => {
        this.clientToken[key] = ''
      })
    }
  }
}
</script>
<style  scoped lang="less">
.bg-white {
  background-color: #fff !important;
  height: 100%;

  /deep/ .van-dialog__confirm {
    background-color: var(--base-green);
    color: #fff;
    border-radius: 10px;
    border: 1px solid var(--base-green);
    margin: 0rem 0.2rem;
  }

  /deep/ .van-dialog__cancel {
    border-radius: 10px;
    border: 1px solid var(--base-green);
    margin: 0rem 0.2rem;
  }

  /deep/ .van-dialog__footer {
    padding: 0rem 0.4rem 0.4rem 0.4rem;
  }
}

.create {
  padding: 0.4rem;

  a {
    color: var(--base-green) !important;
    text-decoration: underline;

    &:link {
      color: var(--base-green) !important;
    }

    &:visited {
      color: var(--base-green) !important;
    }
  }
}

.color-green {
  color: #117281;
}

.no-message {
  .font-large {
    font-size: 0.7rem;
  }

  .font-normal {
    font-size: 0.4rem;
  }

  p {
    margin: 0.3rem;
  }

  padding-bottom:0.3rem;
}

.margin-t-50 {
  margin-top: 50% !important;
}

.close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
</style>
